import { treeSize, treeCmType, featureTypes } from "./types";

export const AppName = "NVR Map";

export const SearchControlPlaceholder =
  "Search by Address or SPI (e.g. 2197\\PP2478)";

export const removalInstructionsText = "How to map native vegetation removal";

export const offsetInstructionsText =
  "How to map native vegetation for protection";

export const initialDrawingMessages = {
  [featureTypes.patch]: "Click to start drawing",
  [featureTypes.tree]: "Click to place tree",
  [featureTypes.revegetationArea]: "Click to start drawing",
};

export const minimumAreaToPerimeterRatio = 20;

export const msaEmailAddress = "msa.habitatcompensation@delwp.vic.gov.au";
export const nvEmailAddress = "nativevegetation.support@delwp.vic.gov.au";

export const replaceFeatureTypeToken = "%REPLACE_FEATURE_TYPE%";

export const replaceOverlappingFeatureTypeToken =
  "%REPLACE_OVERLAPPING_FEATURE_TYPE%";

export const subsequentPolygonDrawingMessage =
  "Click to add more vertices, double-click/Enter to finish";

export const initialEditMessage = "Select a feature to edit";
export const polygonEditMessage =
  "Click and drag to move the feature. You can also reshape it or add/remove vertices";
export const pointEditMessage = "Click and drag to move the feature";

export const invalidAfterMergeMessage = `This change would result in a ${replaceFeatureTypeToken} that is self-intersecting or has a hole in the middle. This type of shape is not supported.`;

export const overlappingPolygonHeading = `Overlapping ${replaceFeatureTypeToken}`;
export const overlappingPolygonMessage = `The ${replaceFeatureTypeToken} you have just drawn overlaps with existing ${replaceFeatureTypeToken}`;
export const overlappingPolygonAfterEditMessage = `The edited ${replaceFeatureTypeToken} overlaps with existing ${replaceFeatureTypeToken}`;

export const noScatteredTreeAllowed = "A patch can only contain Patch Trees";

export const defaultTreeBenchmarkCm = 40 * Math.PI;
export const scatteredTreeOffsetBenchmarkThreshold = 0.75;

export const sizesHelp: Record<string, string> = {
  [treeSize.Lg]: "Large",
  [treeSize.Sm]: "Small",
};

export const cmTypeHelp: Record<string, string> = {
  [treeCmType.DBH]: "Diameter at breast height",
  [treeCmType.CIR]: "Circumference",
};

export const locationText: Record<number, string> = {
  1: "The native vegetation extent map indicates that this area is not typically characterised as supporting native vegetation. It does not meet the criteria to be classified as Location Category 2 or 3. The removal of less than 0.5 hectares of native vegetation in this area will not require a Species Offset.",
  2: "The native vegetation extent map indicates that this area is typically characterised as supporting native vegetation. Additionally, it is modelled as encompassing an endangered Ecological Vegetation Class, sensitive wetland or sensitive coastal area. The removal of less than 0.5 hectares of native vegetation in this area will not require a Species Offset.",
  3: "Within this area, the removal of less than 0.5 hectares of native vegetation could have a significant impact on the habitat of one or more rare or threatened species. In such cases, a Species Offset will be required.",
};

// links
export const guidelines =
  "https://www.environment.vic.gov.au/__data/assets/pdf_file/0021/91146/Guidelines-for-the-removal,-destruction-or-lopping-of-native-vegetation,-2017.pdf";
export const applicantsGuide =
  "https://www.environment.vic.gov.au/__data/assets/pdf_file/0024/90762/NVR-Applicants-Guide-June-2023-Final.pdf";
export const assessorsHandbook =
  "https://www.environment.vic.gov.au/__data/assets/pdf_file/0022/91255/Assessors-handbook-Applications-to-remove,-lop-or-destroy-native-vegetation-V1.1-October-2018.pdf";
export const firstPartyOffsetGuide =
  "https://www.environment.vic.gov.au/__data/assets/pdf_file/0029/329456/First-party-offset-guide.pdf";
export const firstPartyOffsetPlanTemplate =
  "https://www.environment.vic.gov.au/__data/assets/excel_doc/0031/435766/First-party-general-OMP-template_V1.1.xlsm";
export const gainScoringManual =
  "https://www.environment.vic.gov.au/__data/assets/pdf_file/0026/51794/Native-vegetation-gain-scoring-manual-Version-2.pdf";
export const medianCreditPricing =
  "http://www.environment.vic.gov.au/__data/assets/excel_doc/0042/669588/Median_Credit_Pricing.xlsx";
